<template>
  <div>
    <validation-observer ref="NotificationFormValidator">
      <v-form>
        <v-card>
          <v-card-title>{{ $route.params.id ? 'お知らせ編集' : 'お知らせ追加' }}</v-card-title>
          <v-card-text>
            <v-row>
              <!-- 表示終了日時 -->
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="表示終了日時"
                  rules="required"
                >
                  <vue-ctk-date-time-picker
                    v-model="notification.display_end_at"
                    no-value-to-custom-elem
                    no-button-now
                    overlay
                    right
                    color="#0070B3"
                    format="YYYY-MM-DD HH:mm"
                    formatted="YYYY-MM-DD HH:mm"
                  >
                    <v-text-field
                      v-model="notification.display_end_at"
                      :error-messages="errors"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="表示終了日時"
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </vue-ctk-date-time-picker>
                </validation-provider>
              </v-col>
              <!-- /表示終了日時 -->

              <!-- 重要 -->
              <v-col cols="3" md="3">
                <div class="float-right">
                  <v-checkbox
                    v-model="notification.use_important"
                    label="重要"
                    hide-details="auto"
                    class="pa-0 ma-0"
                  />
                </div>
              </v-col>
              <!-- /重要 -->
            </v-row>

            <!-- タイトル -->
            <v-row>
              <v-col cols="12" md="12">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:100"
                  name="タイトル"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="notification.title"
                    :error-messages="errors"
                    label="タイトル"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  >
                    <template v-slot:label>
                      <span>タイトル</span>
                      <span class="ml-1">
                        ({{ notification.title?.length || 0 }} / 100)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /タイトル -->

            <!-- 内容 -->
            <v-row>
              <v-col cols="12" md="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="内容"
                  rules="max:2048"
                >
                  <v-textarea
                    v-model="notification.message"
                    :error-messages="errors"
                    hide-details="auto"
                    label="内容"
                    persistent-placeholder
                    rows="3"
                  >
                    <template v-slot:label>
                      <span>内容</span>
                      <span class="ml-1">
                        ({{ notification.message?.length || 0 }} / 2048)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                  </v-textarea>
                </validation-provider>
              </v-col>
            </v-row>
            <!-- /内容 -->

            <v-card-title>
              <v-radio-group
                v-model="notification.delivery_type"
                row
                dense
                hide-details="auto"
                class="pa-0 ma-0"
              >
                <v-radio
                  label="全体に通知"
                  value="all_delivery"
                />
                <v-radio
                  label="特定のテナントに通知"
                  value="tenant_delivery"
                />
              </v-radio-group>
              <v-spacer />
              <v-btn
                v-if="notification.delivery_type === 'tenant_delivery'"
                color="info"
                small
                @click="openTenantSearchDialog"
              >
                テナント選択
              </v-btn>
            </v-card-title>

            <v-row
              v-if="notification.delivery_type === 'tenant_delivery'"
            >
              <v-col>
                <v-card flat>
                  <v-card-text>
                    <v-data-table
                      :headers="tableHeaders"
                      :items="notification_tenants"
                      hide-default-footer
                      disable-sort
                      disable-pagination
                    >
                      <template v-slot:[`item.editable`]="{ item }">
                        <v-btn
                          icon
                          color="error"
                          @click="tenantRequesterRemoveButtonClickEvent(item)"
                        >
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>

    <!-- /ダイアログ -->
    <tenant-search-dialog
      :enable-dialog="enableTenantDialog"
      @closeEvent="closeTenantDialog"
      @registerEvent="tenantCallback"
    />
    <!-- ダイアログ -->
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import TenantSearchDialog from './dialogs/TenantSearchDialog'
export default {
  name: 'NotificationForm',
  components: {
    TenantSearchDialog,
  },
  mixins: [],
  data () {
    return {
      enableExpiredDatePicker: false,
      enableTenantDialog: false,
      notification_tenants: [],
      notification: {
        id: null,
        notification_type: 'dxe_notification',
        title: null,
        message: null,
        display_end_at: null,
        use_important: false,
        delivery_type: 'all_delivery',
        notification_tenants: []
      },
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'name', text: 'テナント名' },
        { value: 'editable', text: '削除', align: 'end' },
      ],
    }
  },
  created() {
    if (this.$route.params.id) {
      this.editAdminNotification({ id: this.$route.params.id }).then((content) => {
        this.notification = content
        this.remakeDisplayList()
      })
    } else {
      this.newAdminNotification().then((content) => {
        this.notification = content
        this.remakeDisplayList()
      })
    }
  },
  methods: {
    ...mapActions('AdminNotification', {
      newAdminNotification: 'new',
      editAdminNotification: 'edit',
      createAdminNotification: 'create',
      updateAdminNotification: 'update'
    }),
    openTenantSearchDialog () {
      this.enableTenantDialog = true
    },
    closeTenantDialog () {
      this.enableTenantDialog = false
    },
    tenantRequesterRemoveButtonClickEvent (item) {
      item._destroy = true
      this.remakeDisplayList()
    },
    tenantCallback (forms) {
      this.notification.notification_tenants = forms
      this.closeTenantDialog()
      this.remakeDisplayList()
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.NotificationFormValidator.validate().then((result) => {
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      let tenant_ids = null
      if (this.notification.delivery_type === 'tenant_delivery') {
        tenant_ids = this.notification_tenants.map(( v) => v.id )
      }

      let params = {
        notification_type: this.notification.notification_type,
        title: this.notification.title,
        message: this.notification.message,
        display_end_at: this.notification.display_end_at,
        use_important: this.notification.use_important,
        delivery_type: this.notification.delivery_type,
        tenant_ids: tenant_ids
      }

      if (this.notification.id) {
        this.updateAdminNotification({ id: this.notification.id, params: params }).then(() => {
          this.$router.push( { name: 'AdminNotifications' } )
        })
      } else {
        this.createAdminNotification({ params: params }).then(() => {
          this.$router.push( { name: 'AdminNotifications', params: { resetPagination: true } } )
        })
      }
    },
    remakeDisplayList () {
      this.notification_tenants = []
      for (const requester of this.notification.notification_tenants) {
        if (!requester._destroy) {
          this.notification_tenants.push(requester)
        }
      }
    }
  }
}
</script>
